import { Focus_Plain, Focus_, Input_, Red_ } from 'monica-alexandria';
import styled from 'styled-components';

const OfferPreviewSideActions = styled.aside`
    background: ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    padding: var(--normalPads);

    button{
        width: 100%;
        justify-content: center;
    }

    @media print {
        display: none;
    }
`;

const OfferPreviewValidityExtend = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 0.8rem;
`;

const OfferPreviewValidityInput = styled(Input_)`
    width: 10rem;

    input {
        min-height: 4rem;
    }
`;

export default function Offer_Preview_Admin_Actions(props) {
    return (
        <OfferPreviewSideActions>
            {props.canExtend ? (
                <OfferPreviewValidityExtend>
                    <OfferPreviewValidityInput
                        type="number"
                        placeholder={props.copy.extendDays}
                        value={props.extensionDays}
                        onChange={props.onExtensionDaysChange}
                    ></OfferPreviewValidityInput>
                    <Focus_Plain
                        text={props.actionType === 'extend' ? props.copy.extending : props.copy.extend}
                        onClick={props.onExtend}
                    ></Focus_Plain>
                </OfferPreviewValidityExtend>
            ) : null}
            {props.canMarkPaid ? (
                <Focus_
                    text={props.actionType === 'paid'
                        ? props.copy.processing
                        : props.paymentActionText || props.copy.paid}
                    onClick={props.onMarkPaid}
                ></Focus_>
            ) : null}
            {props.canDelete ? (
                <Red_
                    text={props.actionType === 'delete' ? props.copy.deleting : props.copy.delete}
                    onClick={props.onDelete}
                ></Red_>
            ) : null}
        </OfferPreviewSideActions>
    );
}
